'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddConfirmationComponent = exports.parcelAddConfirmationComponent = {
    template: require('./parcel-add-confirmation.html'),
    controllerAs: 'vm',
    bindings: {
        parcel: '<'
    },
    controller: ["common", "gettextCatalog", "Analytics", function parcelAddConfirmationController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.yourParcelWasRegistered');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/add-parcel-confirmation', pageTitle);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/parcel-add-confirmation.js
// module id = 883
// module chunks = 0